import { render, staticRenderFns } from "./SopBlockDetail.vue?vue&type=template&id=1bd2bfa6&scoped=true&"
import script from "./SopBlockDetail.vue?vue&type=script&lang=ts&"
export * from "./SopBlockDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2bfa6",
  null
  
)

export default component.exports